<div
	class="breadcrumbs-step"
	[ngClass]="{ 'is--active': isActive, 'is--completed': isCompleted }"
>
	<span
		*ngIf="isCompleted"
		class="breadcrumbs-step__completed"
		aria-hidden="true"
	></span>
	<span *ngIf="!isCompleted">{{ step }}</span>
</div>
